import React from "react"
import { useTranslation } from "react-i18next"

import { ContentTag } from "scrivito"
import { PortfolioPageObj } from "scrivito/Objs/PortfolioPage/PortfolioPageObjClass"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductCategoryObj } from "scrivito/Objs/ProductCategory/ProductCategoryObjClass"

import {
  ProductFilterFormData,
  hasProductFilter
} from "entities/products/types/ProductFilter"
import { ProductCategoryGrid } from "widgets/product-category-grid/ProductCategoryGrid"
import { ProductFilter } from "widgets/product-filter/ProductFilter"
import { ProductGrid } from "widgets/product-grid/ProductGrid"

import "./styles/_product-category-overview.scss"

interface ProductCategoryOverviewModel {
  page: PortfolioPageObj
  productCategories: ProductCategoryObj[] | undefined
  products: ProductObj[] | undefined

  mode?: "link" | "button"
  onCategorySelect?: (productCategoryObj: ProductCategoryObj) => void
  onProductSelect?: (productObj: ProductObj) => void

  filter?: ProductFilterFormData
  defaultFilter?: ProductFilterFormData
  onFilterChange?: (filterState: ProductFilterFormData) => void
}

export const ProductCategoryOverview = React.memo(
  ({
    page,
    productCategories,
    products,
    mode = "link",
    onCategorySelect,
    onProductSelect,
    filter,
    defaultFilter,
    onFilterChange
  }: ProductCategoryOverviewModel) => {
    const { t } = useTranslation()

    return (
      <div className="product-category-overview">
        <div className="product-category-overview__header">
          <ContentTag
            tag="h1"
            content={page}
            attribute="title"
            className="product-category-overview__title"
          />
          <ProductFilter.Root
            defaultValues={defaultFilter}
            onChange={onFilterChange}
          >
            <ProductFilter.Search className="input--elevated" />
          </ProductFilter.Root>
        </div>
        {filter && hasProductFilter(filter) ? (
          <ProductGrid
            productObjs={products}
            mode={mode}
            onSelect={onProductSelect}
            emptyMessage={t("Product.NoResults")}
          />
        ) : (
          <ProductCategoryGrid
            categories={productCategories}
            mode={mode}
            onSelect={onCategorySelect}
          />
        )}
      </div>
    )
  }
)
